export const isString = (value: any) => typeof value === 'string';
